<template>
    <div id="header">
        <div class="left">
            <div v-if="hasAllRoles(['DeviceView', 'VehicleView', 'DeviceEventView'])" class="expand-menu">
                <button
                    class="hamburger"
                    @click="toggleMenu"
                >
                    <span class="hamburger__box">
                        <span class="hamburger__inner"></span>
                    </span>
                </button>
            </div>
            <logo></logo>

            <sp-menu></sp-menu>
        </div>
        <div class="right">
            <div class="right__impersonate-wrapper" v-if="hasAllRoles(['OrganizationView']) && activeImpersonate">
                <div class="right__spillard">{{ impersonatedOrgName }}</div>
                <div class="right__impersonate">Impersonate</div>
            </div>
            <resource-stats v-if="hasAnyRole(['DeviceView', 'DeviceEventView'])"></resource-stats>
            <profile @handleImpersonatedOrg="handleImpersonatedOrg"></profile>
        </div>
    </div>
</template>

<script>
import Logo from '@/components/layout/header/Logo'
import Menu from '@/components/layout/header/Menu'
import Profile from '@/components/layout/header/Profile'
import ResourceStats from '@/components/layout/header/ResourceStats'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'Header',
    components: {
        'logo': Logo,
        'sp-menu': Menu,
        'profile': Profile,
        'resource-stats': ResourceStats
    },
    data () {
        return {
            impersonatedOrgName: ''
        }
    },
    mounted () {
        if (this.hasAllRoles(['DeviceView', 'VehicleView', 'DeviceEventView'])) {
            this.setMenuAction(true)
        }
    },
    computed: {
        ...mapGetters({
            getMenuState: 'layoutModule/getMenuState'
        }),
        ...mapGetters('authModule', [
            'getActiveOrganization',
            'getDefaultOrganization'
        ]),
        activeImpersonate () {
            return this.getActiveOrganization !== this.getDefaultOrganization
        }
    },
    methods: {
        ...mapActions({
            setMenuAction: 'layoutModule/setMenuAction'
        }),
        toggleMenu () {
            this.setMenuAction(!this.getMenuState)
        },
        handleImpersonatedOrg (currentOrgName) {
            this.impersonatedOrgName = currentOrgName
        }
    }
}
</script>

<style lang="scss">
#header {
    height: get($header-config, default, height);
    background: get($header-config, default, background);
    border-left: get($left-border, width) solid $primary;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.55);
    font-size: 1rem;
    display: flex;
    position: fixed;
    width: 100%;
    z-index: 3;
    .left {
        height: 100%;
        display: flex;
        flex-grow: 0;
        flex-shrink: 1;
        flex-wrap: nowrap;
        margin-right: auto;

        .expand-menu {
            margin-left: 10px;
            margin-right: 10px;
            display: flex;
        }
    }

    .hamburger {
        padding: 10px;
        display: inline-block;
        cursor: pointer;
        background-color: transparent;
        outline: none;
        border: 0;
        margin: 0;
    }

    .hamburger, .navigation {
        transition: transform .3s .1s ease-in-out;
    }

    .hamburger__box {
        width: 25px;
        height: 24px;
        display: inline-block;
        position: relative;
    }

    @mixin hamburger-line {
        width: 100%;
        height: 2px;
        background-color: #fff;
        position: absolute;
    }

    .hamburger__inner {
        @include hamburger-line;
        left: 0;
        top: 70%;
        transform: translateY(-50%);
        transition: background-color .1s .2s ease-in-out;
    }

    .hamburger__inner::before,
    .hamburger__inner::after {
        @include hamburger-line;
        content: '';
        left: 0;
        transition: transform .2s .2s ease-in-out;
    }

    .hamburger__inner::before {
        top: -7px;
    }

    .hamburger__inner::after {
        top: 7px;
    }

    .hamburger--active .hamburger__inner {
        background-color: transparent;
    }

    .hamburger--active .hamburger__inner:before {
        transform: translateY(10px) rotate(45deg);
    }

    .hamburger--active .hamburger__inner:after {
        transform: translateY(-10px) rotate(-45deg);
    }

    .right {
        height: 100%;
        display: flex;
        align-items: center;
        flex-grow: 0;
        flex-shrink: 1;
        flex-wrap: nowrap;
        margin-left: auto;

        &__impersonate-wrapper {
            display: flex;
            flex-direction: column;
            padding-right: 0;
            padding-left: 5px;
            position: relative;

            @media (min-width: 962px) {
                padding-left: 0;
                padding-right: 15px;
            }

            &:after {
                content: '';
                height: 30px;
                width: 1px;
                background-color: $white;
                position: absolute;
                right: -7px;
                top: 4px;
            }
        }

        &__spillard {
            font-size: 12px;
            color: $white;

            @media (min-width: 840px) {
                font-size: 16px;
            }
        }

        &__impersonate {
            font-size: 9px;
            color: #aaaaaa;
        }
    }
}
</style>
